import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Tercero } from '../../_models/tercero';
import { NavService } from '../../_services/_nav.service';
import { Funcionalidad } from '../../_models/funcionalidad';
import { TipoTerceroClasificacionService } from '../../_services/tipo-tercero-clasificacion.service';
import { ConstanteService } from '../../_services/constante.service';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TerceroService } from '../../_services/tercero.service';
import { RetornoFuncionalidades } from '../../_models/retorno-funcionalidades';
import { TipoTerceroClasificacion } from '../../_models/tipo-tercero-clasificacion';
import { TerceroTipoTerceroService } from '../../_services/tercero-tipo-tercero.service';
import { TerceroTipoClasificacionService } from '../../_services/tercero-tipo-clasificacion.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { AliadoService } from '../../_services/aliado.service';
import { Aliado } from '../../_models/aliado';

@Component( {
  selector: 'app-aliados-seleccionar',
  templateUrl: 'aliados-seleccionar.component.html'
} )

export class AliadosSeleccionarComponent implements OnInit {

  carInformacionInicial = true;
  formulario: FormGroup;
  submitted = false;
  lisTipoDocumento: SelectItem[] = [];
  tiposDocumentos: ListaItem[] = [];
  consultando = false;
  tercero: Tercero;
  guardando = false;
  menu: Funcionalidad = new Funcionalidad();
  conCorrecta = false;
  valConstante: string[] = [];
  claConstante: TipoTerceroClasificacion = new TipoTerceroClasificacion();

  constructor( private fb: FormBuilder,
               private navServicio: NavService,
               private claTiposTercerosServicio: TipoTerceroClasificacionService,
               private lisServicio: ListaService,
               private router: Router,
               private route: ActivatedRoute,
               private confServicio: ConfirmationService,
               private terTipoTerceroService: TerceroTipoTerceroService,
               private terTipoClasificacionService: TerceroTipoClasificacionService,
               private terServicio: TerceroService,
               private autServicio: AutenticacionService,
               private aliServicio: AliadoService,
               private conServicio: ConstanteService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'ter/terceros' );
    if ( mn ) {
      this.menu = mn;
    }

    this.formulario = this.fb.group( {
      numeroDocumento: [ null, [ Validators.required ] ],
      tipoDocumento: [ null, [ Validators.required ] ]
    } );

    this.navServicio.resetRetornoFuncionalidades();

    this.lisServicio.getMasterDetails( 'ListasTiposDocumentos' ).subscribe( res => {
      this.tiposDocumentos = res;
      res.map( ( s: ListaItem ) => {
        this.lisTipoDocumento.push( { label: s.nombre, value: s.idLista } );
      } );
    } );

    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.terServicio.get( params[ 'id' ] ).subscribe( third => {
          if ( third.indicadorHabilitado ) {
            this.tercero = third;
          }
          this.cargarConstante();
        } );
      } else {
        this.cargarConstante();
      }
    } );

  }

  cargarConstante() {
    this.conServicio.getByCode( 'DINALI' ).subscribe( constante => {
      if ( constante && constante.valor && constante.valor.length > 0 ) {
        const tipClasificacionTercero = constante.valor.split( ';' );
        if ( tipClasificacionTercero.length > 1 ) {
          this.claTiposTercerosServicio.getByCode( tipClasificacionTercero[ 1 ] ).subscribe( clasificacion => {
            if ( clasificacion.codigoTerceroTipo === tipClasificacionTercero[ 0 ] ) {
              this.conCorrecta = true;
              this.claConstante = clasificacion;
              this.valConstante = tipClasificacionTercero;
              this.carInformacionInicial = false;
            } else {
              this.navServicio.setMesage( 4, {
                severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
                detail: this.navServicio.buscarMensaje( 'CONSTANTES.MSG_CONFIGURADAERRONEA' )
              } );
              this.carInformacionInicial = false;
            }
          }, error => {
            this.navServicio.setMesage( 4, {
              severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
              detail: this.navServicio.buscarMensaje( 'CONSTANTES.MSG_CONFIGURADAERRONEA' )
            } );
            this.carInformacionInicial = false;
          } );
        } else {
          this.navServicio.setMesage( 4, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
            detail: this.navServicio.buscarMensaje( 'CONSTANTES.MSG_CONFIGURADAERRONEA' )
          } );
          this.carInformacionInicial = false;
        }
      } else {
        this.navServicio.setMesage( 4, {
          severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
          detail: this.navServicio.buscarMensaje( 'CONSTANTES.MSG_NOCONFIGURADA' )
        } );
        this.carInformacionInicial = false;
      }
    }, error => {
      this.carInformacionInicial = false;
      this.navServicio.setMesage( 4, {
        severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
        detail: this.navServicio.buscarMensaje( 'CONSTANTES.MSG_NOEXISTE' )
      } );
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.consultando = true;
      this.terServicio.validateDocument( this.f.numeroDocumento.value, this.f.tipoDocumento.value ).subscribe( data => {

        if ( data && data.indicadorHabilitado ) {
          this.tercero = data;
        } else {
          this.tercero = undefined;
        }

        if ( !this.tercero ) {
          let mensaje = this.navServicio.buscarMensaje( 'LBL_TERCERONOEXISTE' );
          if ( this.menu.agregar && this.menu.editar ) {
            mensaje = this.navServicio.buscarMensaje( 'LBL_TERCEROEXISTE' );
          }

          this.confServicio.confirm( {
            message: mensaje,
            header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
            icon: 'fa fa-question-circle',
            accept: () => {
              if ( this.menu.editar && this.menu.agregar ) {
                this.crearTercero();
              }
            },
            reject: () => {
              this.limpiar();
            }
          } );
        }
        this.consultando = false;
      } );


    }
  }

  get f() {
    return this.formulario.controls;
  }

  regresar() {
    this.router.navigate( [ 'apl/aliados' ] );
  }

  limpiar() {
    this.formulario.reset();
    this.tercero = null;
    this.submitted = false;
  }

  seleccionar() {
    if ( this.conCorrecta ) {
      this.guardando = true;
      this.aliServicio.obtenerPorTercero( this.tercero.idTercero ).subscribe( aliado => {
        this.terTipoClasificacionService.insertNotExist( this.tercero.idTercero,
          this.claConstante.idTerceroTipoClasificacion )
          .subscribe( cla => {
            if ( !aliado ) {
              const a = {} as Aliado;
              a.idTercero = this.tercero.idTercero;
              a.indicadorHabilitado = true;
              this.aliServicio.crear( a ).subscribe( l => {
                this.guardando = false;
                this.router.navigate( [ 'apl/aliados/sucursales/' + l.idAliado ] );
              } );
            } else if ( !aliado.indicadorHabilitado ) {
              aliado.indicadorHabilitado = true;
              this.aliServicio.actualizar( aliado ).subscribe( l => {
                this.guardando = false;
                this.router.navigate( [ 'apl/aliados/sucursales/' + aliado.idAliado ] );
              } );
            } else {
              this.guardando = false;
              this.router.navigate( [ 'apl/aliados/sucursales/' + aliado.idAliado ] );
            }
          }, error => {
            this.guardando = false;
            this.navServicio.setMesage( 3 );
          } );
      } );


    } else {
      this.navServicio.setMesage( 4, {
        severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
        detail: this.navServicio.buscarMensaje( 'CONSTANTES.MSG_CONFIGURADAERRONEA' )
      } );
    }
  }

  crearTercero() {
    let retFuncionalidad: RetornoFuncionalidades = {
      identificador: 'SELTER',
      proceso: this.navServicio.buscarMensaje( 'LBL_SELECCIONTERCERO' ),
      ruta: 'apl/aliados/seleccionar-tercero',
      constante: 'DINALI',
      idProceso: null,
      otros: null
    };
    this.navServicio.setRetornoFuncionalidad( retFuncionalidad );
    this.router.navigate( [ 'ter/terceros/agregar' ] );

  }
}
